import React from 'react';
import {translate} from 'react-i18next';

function TranslatedText(props) {
    const {t, tag} = props;

    return <span dangerouslySetInnerHTML={{__html: t(tag) || 'NO_TAG'}} />;
}

export default translate()(TranslatedText);



// WEBPACK FOOTER //
// ./src/atoms/TranslatedText.js